export const IdentityCardAlias = "Alias";
export const IdentityCardContact = "Contact";
export const IdentityCardContactInfo = "Contact information";
export const IdentityCardDepartment = "Department";
export const IdentityCardDistributionList = "Distribution list";
export const IdentityCardEmail = "Email";
export const IdentityCardHeaderButtonLabel = "Go back";
export const IdentityCardLoadingText = "Loading identities...";
export const IdentityCardLocation = "Location";
export const IdentityCardMembers = "{0} members";
export const IdentityCardMembersCount = "Members ({0})";
export const IdentityCardNoResultsText = "No identities found";
export const IdentityCardOrganization = "Organization";
export const IdentityCardPhoneNumber = "Phone number";
export const IdentityCardPlaceholderText = "Search users and groups";
export const IdentityCardProfileCardAriaLabel = "Contact card";
export const IdentityCardReportingTo = "Reporting to {0} ({1})";
export const IdentityCardReportsTo = "Reports to";
export const IdentityCardResultsFoundText = "Showing {0} results";
export const IdentityCardStartChat = "Start chat";
export const IdentityCardTitle = "Title";
export const IdentityCardUnknownUser = "Unknown user";
export const Loading = "Loading...";
